import { onlineUrlError } from './online_url';

describe('onlineUrlError', () => {
  it('リアル開催なら接続先URLが空でもエラーにしない', () => {
    expect(onlineUrlError({ isOnline: false, url: '' })).toBe('');
  });

  it('オンライン開催で接続先URLが空なら必須エラーにする', () => {
    expect(onlineUrlError({ isOnline: true, url: '' })).toBe(
      '接続先URLを入力してください。',
    );
  });

  it('http/https 以外のURLは形式エラーにする', () => {
    expect(onlineUrlError({ isOnline: true, url: 'zoom.us/j/123' })).toBe(
      'http:// または https:// から始まるURLを入力してください。',
    );
    expect(onlineUrlError({ isOnline: true, url: 'javascript:alert(1)' })).toBe(
      'http:// または https:// から始まるURLを入力してください。',
    );
  });

  it('http/https のURLは有効とする', () => {
    expect(
      onlineUrlError({ isOnline: true, url: 'https://zoom.us/j/123' }),
    ).toBe('');
    expect(
      onlineUrlError({ isOnline: true, url: 'http://meet.example.com/room' }),
    ).toBe('');
  });

  it('前後の空白を除けば有効なURLは許可する', () => {
    expect(
      onlineUrlError({ isOnline: true, url: '  https://zoom.us/j/123  ' }),
    ).toBe('');
  });
});
